module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.i18next) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md4": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [(_vm.$route.params.level1) ? [_c('v-subheader', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$route.params.level1)))]), _vm._v(" "), _vm._l((_vm.i18next['en']['translation'][_vm.$route.params.level1]), function(val, key) {
    return _c('v-list-item', {
      key: key,
      attrs: {
        "href": _vm.getEditTextLink(_vm.$route.params.level1, key)
      }
    }, [_c('v-list-item-content', [(key === _vm.$route.params.level2) ? _c('v-list-item-title', [_c('b', [_vm._v(_vm._s(val))])]) : _c('v-list-item-title', [_vm._v(_vm._s(val))])], 1)], 1)
  })] : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Kategorien")]), _vm._v(" "), _vm._l((_vm.accordionKeys), function(header) {
    return _c('v-list-item', {
      key: header,
      attrs: {
        "href": _vm.getEditTextLink(header)
      }
    }, [_c('v-list-item-content', [(header === _vm.$route.params.level1) ? _c('v-list-item-title', [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(header)))])]) : _c('v-list-item-title', [_vm._v(_vm._s(_vm._f("capitalize")(header)))])], 1)], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md8": ""
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "20px",
      "padding-top": "20px"
    }
  }, [(_vm.$route.params.level2) ? _c('router-view', {
    attrs: {
      "texts": _vm.texts
    },
    on: {
      "save": function (config) { return _vm.saveTexts(config); }
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-c0f5ab2c"}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsTextsDialog.vue
// module id = 951
// module chunks = 1